export default __webpack_public_path__ + "static/media/about-me-img.117f1bb0.jpg";